import { makeStyles } from 'tss-react/mui';

export const useSelectStyles = makeStyles()(() => ({
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
}));
